var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backDoor",style:('background-image: url(https://www.swetlow.de/vika/advent/'+_vm.no+'.jpg)')},[_c('div',{staticClass:"door",class:[_vm.open ? 'doorOpen' : ''],on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.no)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }